import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from '../module';

export const EMBEDDED_TOKEN_FETCHING = prefix('EMBEDDED_TOKEN_FETCHING');
export const [EMBEDDED_TOKEN_FETCHING_STARTED, EMBEDDED_TOKEN_FETCHING_SUCCEEDED, EMBEDDED_TOKEN_FETCHING_FAILED] =
    createAsyncActionTypes(EMBEDDED_TOKEN_FETCHING);

export const EMBEDDED_TOKEN_CONFIGURATION_FETCHING = prefix('EMBEDDED_TOKEN_CONFIGURATION_FETCHING');
export const [
    EMBEDDED_TOKEN_CONFIGURATION_FETCHING_STARTED,
    EMBEDDED_TOKEN_CONFIGURATION_FETCHING_SUCCEEDED,
    EMBEDDED_TOKEN_CONFIGURATION_FETCHING_FAILED,
] = createAsyncActionTypes(EMBEDDED_TOKEN_CONFIGURATION_FETCHING);

export const EMBEDDED_TOKEN_CLEARED = prefix('EMBEDDED_TOKEN_CLEARED');
export const POWERBI_ANALYTICS_TYPE_SET = prefix('POWERBI_ANALYTICS_TYPE_SET');
export const DATA_INTEGRITY_VIOLATED = prefix('DATA_INTEGRITY_VIOLATED');

export const BOOKMARK_CAPTURED = prefix('BOOKMARK_CAPTURED');
export const BOOKMARK_CLEARED = prefix('BOOKMARK_CLEARED');

export const UPDATE_EVENT_TIMER = prefix('UPDATE_EVENT_TIMER');
